import { useMemo } from 'react';
const useUniqueSchedules = (schedules: any[]) => {
    const uniqueSchedules = useMemo(() => {
        
        // Helper function to extract and parse doctor IDs
        const extractDoctorIds = (item: any) => {
            const ids = Array.isArray(item.sch_doctor_ids)
                ? item.sch_doctor_ids.map(String) // Convert all items to strings
                : [String(item.sch_doctor_ids)]; // Convert to array of single string element
            return ids.filter((id: string) => id.trim() !== ''); // Remove empty strings
        };

        // Create a new array to hold the separated schedules
        const separatedSchedules: any[] = [];

        // Loop through each schedule and create separate entries for each doctor ID
        schedules.forEach(schedule => {
            const doctorIds = extractDoctorIds(schedule);
            doctorIds.forEach((doctorId: any) => {
                const newSchedule = { ...schedule, sch_doctor_ids: doctorId }; // Ensure sch_doctor_ids is an array
                separatedSchedules.push(newSchedule);
            });
        });

        // Use a Set to filter out schedules with duplicate doctor IDs and address IDs
        const uniqueSchedules = separatedSchedules.filter((item, index, self) => {
            return index === self.findIndex(i => (
                i.sch_doctor_ids === item.sch_doctor_ids && i.address_id === item.address_id
            ));
        });

           // Sort the unique schedules by doctor ID
        uniqueSchedules.sort((a, b) => {
            const doctorIdA = parseInt(a.sch_doctor_ids, 10);
            const doctorIdB = parseInt(b.sch_doctor_ids, 10);
            return doctorIdA - doctorIdB;
        });
        return uniqueSchedules;
    }, [schedules]);

    return uniqueSchedules;
};

export default useUniqueSchedules;
